module.exports = __webpack_public_path__ + "static/pattern-design-09-28195c9ef1afc9dc3cf309cc541890ab.jpg";